import React, { useEffect, useState } from "react";

import Nav from "../components/Nav.js";
import config from "../config.js";
import { genericErrorMsg, isAdmin, isSuperAdmin } from "../utils.js";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import {IoAddOutline} from "react-icons/io5";
import AddRoomModal from "../components/AddRoomModal.js";
import ConfirmationModal from "../components/ConfirmationModal.js";
import {MdMode, MdDelete} from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import {BsCheckLg} from "react-icons/bs";
import Select, { createFilter } from 'react-select';
import Form from 'react-bootstrap/Form';

export default function RoomsPage() {

    const [rooms, setRooms] = useState([]);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    
    const [roomsSelected, setRoomsSelected] = useState(0);
    const [showBookableModal, setShowBookableModal] = useState(false);
    const [showUnbookableModal, setShowUnbookableModal] = useState(false);

    const [locations, setLocations] = useState([]);
    const [roomTypes, setRoomTypes] = useState([]);

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);

    const [selectedRoom, setSelectedRoom] = useState(null);

    const fetchRooms = () => {
        fetch(`${config.server_base_url}/api/rooms`)
            .then((response) => response.json())
            .then((data) => setRooms(data.rooms))
            .catch(error => toast.error( genericErrorMsg, {theme: 'colored'}));
    }    

    const deleteRoom = (roomId) => {
        fetch(`${config.server_base_url}/api/rooms/${roomId}`, 
            {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => response.json())
            .then((data) => { if (data.success) fetchRooms() })
            .catch(error => toast.error( genericErrorMsg, {theme: 'colored'}));
      }

    const fetchLocations = () => {
        fetch(`${config.server_base_url}/api/locations`)
            .then((response) => response.json())
            .then((data) => setLocations(data.locations.map(l=>{return {value: l.id, label: l.name}})));
    }  
            
    const fetchRoomTypes = () => {
        fetch(`${config.server_base_url}/api/roomTypes`)
            .then((response) => response.json())
            .then((data) => setRoomTypes(data.roomTypes.map(rt=>{return {value: rt.id, label: rt.name}})));
    }    

    const makeBookable = (bookable) => {
        fetch(`${config.server_base_url}/api/rooms/makeBookable`, 
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                roomIds: [...document.querySelectorAll(`.room-check input:checked`)].map(c=>parseInt(c.value)),
                bookable: bookable
              })
            })
            .then((response) => response.json())
            .then((data) => { if (data.success) {unselectAllRooms(); fetchRooms(); } })
            .catch(error => toast.error( genericErrorMsg, {theme: 'colored'}));

    }
    
    const selectFilterStyles = { menuPortal: (base) => ({ ...base, fontSize: '14px', zIndex: 6 }), control: (base) => ({ ...base, fontSize: '14px', paddingTop: 0 }) };

    const selectedRoomsChanged = () => {
        setRoomsSelected(document.querySelectorAll('.room-check input:checked').length);
    }

    const unselectAllRooms = () => {
        document.querySelector('#check-rooms-all').checked=false;
        [...document.querySelectorAll(`.room-check input`)].forEach(c=>c.checked=false);
        selectedRoomsChanged();
    }

    useEffect(() => {
        unselectAllRooms();
    },[selectedLocations, selectedRoomTypes])

    useEffect(() => {
        fetchRooms();
        fetchLocations();
        fetchRoomTypes();
    },[])

    return (
      <div id='app-container' className="app-container">
        <Nav url="/rooms"></Nav>
        <div className='page-header'><h1>Rooms</h1></div>
        <div id='page-container' className="page-container rooms-page">  
            <div className='data-table-container'>
                <div className='table-actions table-filters'>
                    <label className='filter-group'>Filter rooms:</label>
                    <div className="location-filter">
                        <Select options={locations} onChange={(locs) => (async ()=>setSelectedLocations(locs.map(l=>l.value)))()} isMulti placeholder="All locations" menuPortalTarget={document.body} styles={selectFilterStyles}/>
                    </div>
                    <div className="room-type-filter">
                        <Select options={roomTypes} onChange={(rts) => (async ()=>setSelectedRoomTypes(rts.map(rt=>rt.value)))()} isMulti placeholder="All room types" menuPortalTarget={document.body} styles={selectFilterStyles}/>
                    </div>
                    <div style={{flex: '1 1 0px'}} />
                    <Button variant="primary" style={{marginLeft: 5, marginRight:5}} disabled={!(isAdmin() || isSuperAdmin()) || roomsSelected==0} onClick={()=>{setSelectedRoom(null); setShowBookableModal(true); }}>Make bookable</Button>
                    <Button variant="primary" style={{marginRight:5}} disabled={!(isAdmin() || isSuperAdmin()) || roomsSelected==0} onClick={()=>{setSelectedRoom(null); setShowUnbookableModal(true); }}>Make unbookable</Button>
                    <Button variant="primary" disabled={!(isAdmin() || isSuperAdmin())} onClick={()=>{setSelectedRoom(null); setShowAddModal(true); }}><IoAddOutline /> Create</Button>
                </div>
                <Table striped bordered hover className='rooms-table'>
                    <thead>
                        <tr>
                            <td><Form.Check type='checkbox' id={`check-rooms-all`} onChange={(e)=>
                                    {
                                        [...document.querySelectorAll(`.room-check input`)].forEach(c=>{
                                            c.checked=e.target.checked
                                        });
                                        selectedRoomsChanged();
                                    }} /></td>
                            <td>Room</td>
                            <td>Type</td>
                            <td>Location</td>
                            <td>Bookable</td>
                            <td>Actions</td>
                        </tr>
                    </thead>

                    <tbody>
                        {rooms && rooms.length > 0 && rooms.filter(room=>
                            (selectedLocations.length==0 || selectedLocations.includes(room.locationId)) && (selectedRoomTypes.length==0 || selectedRoomTypes.includes(room.roomTypeId))).map((room) => (
                            <tr key={room.id}>
                                <td><Form.Check type='checkbox' className='room-check' name={`room${room.id}`} value={room.id} onChange={(e)=>{document.querySelector('#check-rooms-all').checked=document.querySelectorAll('.room-check input:checked').length==document.querySelectorAll('.room-check input').length; selectedRoomsChanged();}} /></td>
                                <td>{room.name}</td>
                                <td>{room.roomType.name}</td>
                                <td>{room.location.name}</td>
                                <td>{room.isBookable ? <BsCheckLg /> : ''}</td>
                                <td className='row-actions'>                                    
                                    <Button variant='light' onClick={()=> {setShowAddModal(true); setSelectedRoom({roomId: room.id, roomName: room.name, roomTypeId: room.roomTypeId, locationId: room.locationId, roomIsBookable: room.isBookable, childRoomIds: JSON.parse(room.childRoomIds)}); }}><MdMode /></Button>
                                    <Button variant='light' onClick={()=>{setShowDeleteModal(true); setSelectedRoom({roomId: room.id, roomName: room.name});}} disabled={!(isAdmin() || isSuperAdmin())}><MdDelete /></Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
        {showAddModal ? <AddRoomModal {...selectedRoom} onCancel={()=>setShowAddModal(false)} onSave={()=>fetchRooms()} /> : <span></span>}
        {showDeleteModal ? <ConfirmationModal title={`Are you sure you want to delete <em>${selectedRoom.roomName}</em> ?`} body="This is irreversible." onCancel={()=>setShowDeleteModal(false)} onConfirm={()=>deleteRoom(selectedRoom.roomId)} /> : <span></span>}
        {showBookableModal ? <ConfirmationModal title="Are you sure you want to make these rooms <em>bookable</em> ?" body={`${roomsSelected} rooms will be made bookable.`} onCancel={()=>setShowBookableModal(false)} onConfirm={()=>makeBookable(true)} /> : <span></span>}
        {showUnbookableModal ? <ConfirmationModal title="Are you sure you want to make these rooms <em>unbookable</em> ?" body={`${roomsSelected} rooms will be made unbookable.`} onCancel={()=>setShowUnbookableModal(false)} onConfirm={()=>makeBookable(false)} /> : <span></span>}
        <ToastContainer />
      </div>
    )
  }